import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiService, Control, Hazard } from "../../api";
import { Table } from "antd";

type ExtendedHazard = Hazard & {
  controls?: Control[];
};

type Props = {
  schema: any;
  formProps: any;
  formId?: number;
  requestId?: number;
  readonly?: boolean;
  values?: any;
  onSuccess: (result: any) => void;
};

const AssessmentViewComponent = ({
  schema,
  formProps,
  formId,
  requestId,
  readonly,
  values,
  onSuccess,
}: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [hazards, setHazards] = useState<ExtendedHazard[]>([]);

  useEffect(() => {
    (async () => {
      setLoading(true);

      getFormValues(requestId, formId);

      setLoading(false);
    })();
  }, [formId, requestId]);

  const getFormValues = async (requestId?: number, form_id?: number) => {
    if (!requestId) return undefined;
    const result = await ApiService.apiMainRequestFormRetrieve(
      form_id!,
      requestId!
    );

    setHazards(result);
  };

  const expandedRowRender = (record: ExtendedHazard) => {
    return (
      <Table
        dataSource={record.controls}
        bordered
        pagination={false}
        rowKey="id"
      >
        <Table.Column title={t("Name")} dataIndex="name"></Table.Column>
        <Table.Column
          title={t("Description")}
          dataIndex="description"
        ></Table.Column>
      </Table>
    );
  };

  const columns = [
    {
      title: t("ID"),
      dataIndex: "id",
    },
    {
      title: t("Name"),
      dataIndex: "name",
    },
    {
      title: t("Description"),
      dataIndex: "description",
    },

    {
      title: t("Initial Risk"),
      dataIndex: "initial_risk",
    },
    {
      title: t("Residual Risk"),
      dataIndex: "residual_risk",
    },
  ];

  return (
    <div>
      <Table
        bordered
        loading={loading}
        dataSource={hazards}
        expandable={{ expandedRowRender }}
        rowKey="id"
        columns={columns}
      ></Table>
    </div>
  );
};

export default AssessmentViewComponent;
